<template>
  <div class="modal-wrap modal-wrap--35">
    <div class="modal-header">
      <p class="mb-15 bold">Ny Visning<br>
      </p>
    </div>

    <div class="modal-content">
      <input type="text" class="width-100" placeholder="Datum" onfocus="this.type='date'" v-model="showingDate">

      <div class="grid2col mt-15 mb-25">
        <div><input type="text" placeholder="Starttid" class="width-100" onfocus="this.type='time'" v-model="showingStartTime"></div>
        <div><input type="text" placeholder="Sluttid" class="width-100" onfocus="this.type='time'" v-model="showingEndTime"></div>
      </div>
      <div class="grid2col">
        <div class="flex justify-between mb-15">
          <span>Dölj starttid</span>
          <label class="switch mr-10" style="width: 33px;">
            <input type="checkbox" class="mr-5" v-model="showingHideStartTime">
            <div class="slider round"></div>
          </label>
        </div>

        <div class="flex justify-between mb-15">
          <span>Dölj sluttid</span>
          <label class="switch mr-10" style="width: 33px;">
            <input type="checkbox" class="mr-5" v-model="showingHideEndTime">
            <div class="slider round"></div>
          </label>
        </div>
      </div>

      <div class="grid2col mb-45 mt-15 align-middle">
        <span>Kommentar</span>
        <div class="mr-5 comment-wrap">
          <select class="discreet text-right" v-model="showingComment">
            <option value="" disabled hidden>Välj</option>
            <option :value="comment.text" v-for="comment in comments" v-bind:key="comment.id">{{ comment.text }}</option>
          </select>
          <div class="customer-comment-btn" @click="toggleCustomComment">Anpassade kommentar</div>
        </div>
        <transition name="slide-fade">
          <input v-show="customComment" type="text" class="customer-comment-input mt-10" placeholder="Anpassad kommentar" v-model="showingCustomComment">
        </transition>

      </div>


      <div class="tab pb-25 mb-25" :class="tab1 ? 'active' : ''">
        <label class="tab-label bold db" @click="tab1 = !tab1">Slottar<img src="@/assets/icons/arrow.svg" alt="icon" class="ml-10 arrow"></label>
        <transition name="slide-fade">
          <div class="tab-content" v-show="tab1">
            <div class="flex justify-between mb-10 mt-15 align-middle">
              <span>Välj intervall</span>
              <div style="width: 200px;" class="mr-5">
                <select class="discreet text-right" v-model="showingInterval">
                  <option value="" disabled hidden>Välj intervall</option>
                  <option value="10">10 min</option>
                  <option value="15">15 min</option>
                  <option value="20">20 min</option>
                  <option value="30">30 min</option>
                  <option value="45">45 min</option>
                  <option value="60">60 min</option>
                </select>
              </div>
            </div>

            <input type="number" placeholder="Samtidigt" class="width-100" v-model="showingMaxVisitorsSlot">

            <div class="flex justify-between mt-10 align-middle">
              <span>Publicera slottar</span>
              <div style="width: 200px;" class="mr-5">
                <select class="discreet text-right" v-model="showingPublishInterval">
                  <option value="" disabled hidden>Välj</option>
                  <option value="1">Visa alla slottar</option>
                  <option value="2">Endast första lediga slott</option>
                </select>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="tab pb-25 mb-25" :class="tab2 ? 'active' : ''">
        <label class="tab-label bold db" @click="tab2 = !tab2">Notifiering<img src="@/assets/icons/arrow.svg" alt="icon" class="ml-10 arrow"></label>
        <transition name="slide-fade">
          <div class="tab-content" v-show="tab2">
            <div class="flex justify-between mb-25 mt-15 align-middle">
              <span>Meddela mäklaren när återstående bokningsbara platser är</span>
              <div style="width: 200px;" class="mr-5">
                <select class="discreet text-right" v-model="notifySlotQuantity">
                  <option value="" disabled hidden>Välj</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
            </div>

            <div class="flex justify-between mb-10 align-middle">
              <span>Meddela ansvarig mäklare via</span>
              <div style="width: 200px;" class="mr-5">
                <select class="discreet text-right" v-model="notifySlotQuantityDeliveryWay">
                  <option value="" disabled hidden>Välj</option>
                  <option value="1">Mejl</option>
                  <option value="2">SMS</option>
                  <option value="3">Mejl och SMS</option>
                  <option value="0">Inget</option>
                </select>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="flex justify-between mt-15 mb-25">
        <span>Öppen anmälan</span>
        <label class="switch mr-10" style="width: 33px;">
          <input type="checkbox" class="mr-5" v-model="openForRegistration">
          <div class="slider round"></div>
        </label>
      </div>

      <div class="flex justify-between mb-15">
        <span>Publik</span>
        <label class="switch mr-10" style="width: 33px;">
          <input type="checkbox" class="mr-5" v-model="showingPublic">
          <div class="slider round"></div>
        </label>
      </div>

      <input type="text" placeholder="Intern notering" class="mt-15 width-100" v-model="showingPrivateComment">
    </div>

    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abortForm">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
    <spinner v-show="loading"/>
  </div>
</template>

<script>
import spinner from '../../spinner';
import Bugsnag from '@bugsnag/js';

export default {
  name: 'newShowing',
  data() {
    return {
      date: new Date().toISOString().slice(0, 10),
      time: new Date().toLocaleTimeString().slice(0, 5),
      showingDate: '',
      showingStartTime: '',
      showingEndTime: '',
      showingHideStartTime: '',
      showingHideEndTime: '',
      showingInterval: '',
      showingPublishInterval: '',
      showingPublic: '',
      showingMaxVisitorsSlot: '',
      openForRegistration: '',
      showingPrivateComment: '',
      showingComment: '',
      showingCustomComment: '',
      notifySlotQuantity: '',
      notifySlotQuantityDeliveryWay: '',
      comments: [
        { id: 0, text: 'Välkommen på visning!'},
        { id: 1, text: 'Föranmälan krävs, kontakta mäklaren för anmälan.'},
        { id: 2, text: 'Öppen visning men föranmälan uppskattas.'},
      ],
      loading: false,
      tab1: false,
      tab2: false,
      isEditing: false,
      showingId: null,
      customComment: false
    }
  },
  methods: {
    save() {
      if (
          !this.showingDate.length ||
          !this.showingStartTime.length ||
          !this.showingEndTime.length
      ) {
        alert("Alla fält är inte ifyllda, vänligen fyll i alla fält och försök igen.");
        return;
      }
      this.loading = true;
      let data = {
        showingDate: this.showingDate,
        showingStartTime: this.showingStartTime,
        showingEndTime: this.showingEndTime,
        showingInterval: this.showingInterval === "Inget" ? '' : parseInt(this.showingInterval),
        showingMaxVisitorsSlot: parseInt(this.showingMaxVisitorsSlot),
        showingHideStartTime: this.showingHideStartTime ? 1 : 0,
        showingHideEndTime: this.showingHideEndTime ? 1 : 0,
        showingPublishInterval: this.showingPublishInterval.length ? parseInt(this.showingPublishInterval) : 1,
        showingRealtor: this.$store.state.showing.currentListingWithActiveShowing.realtor.id,
        showingPrivateComment: this.showingPrivateComment,
        showingPublic: this.showingPublic ? 1 : 0,
        showingFkobject: this.$route.params.id,
        showingComment: this.showingCustomComment ? this.showingCustomComment : this.showingComment,
        notifySlotQuantity: this.notifySlotQuantity ? this.notifySlotQuantity : 2,
        notifySlotQuantityDeliveryWay: this.notifySlotQuantityDeliveryWay ? this.notifySlotQuantityDeliveryWay : 1,
        openForRegistration: this.openForRegistration ? this.openForRegistration : 1,
      };

      if (this.isEditing) {
        data.showingId = this.showingId;
      }

      this.$root.callFasAdApi("/internalapi/showing/create-showing", "POST", data)
      .then((data) => {
        this.$root.handleResponseMessage(data);
        // refresh data
        this.$store.dispatch('showing/storeShowingDataForSelectedListing', { listingId: this.$route.params.id });
        // reset the Showing form
        this.resetNewShowingForm();
        this.loading = false;
        this.$store.commit('STORE_ACTIVE_COMPONENT', null);
        this.$root.modalOpen = false;
      })
      .catch((error) => {
        Bugsnag.notify(error);
        Bugsnag.notify(data);
      });
    },
    resetNewShowingForm() {
      this.showingDate = '';
      this.showingStartTime = '';
      this.showingEndTime = '';
      this.showingInterval = '';
      this.showingMaxVisitorsSlot = '';
      this.showingHideStartTime = false;
      this.showingHideEndTime = false;
      this.showingPublishInterval = '';
      this.showingPrivateComment = '';
      this.openForRegistration = false;
      this.showingPublic = false;
      this.showingComment = '';
      this.showingCustomComment = '';
      this.notifySlotQuantity = '';
      this.notifySlotQuantityDeliveryWay = '';
    },
    toggleCustomComment() {
      this.customComment = !this.customComment
      this.showingCustomComment = '';
    },
    abortForm() {
      this.$root.abortForm();
      this.$store.commit('showing/STORE_CURRENT_SHOWING', null);
    },
  },
  components: {
    spinner
  },
  created() {
    if (this.$store.state.showing.currentShowing !== null) {
      this.isEditing = true;
      this.id = this.$store.state.showing.currentShowing.id
      this.showingDate = this.$store.state.showing.currentShowing.showingDate
      this.showingStartTime = this.$store.state.showing.currentShowing.showingStartTime;
      this.showingEndTime = this.$store.state.showing.currentShowing.showingEndTime;
      this.showingInterval = this.$store.state.showing.currentShowing.showingInterval;
      this.showingMaxVisitorsSlot = this.$store.state.showing.currentShowing.showingMaxVisitorsSlot;
      this.showingHideStartTime =  this.$store.state.showing.currentShowing.showingHideStartTime;
      this.showingHideEndTime = this.$store.state.showing.currentShowing.showingHideEndTime;
      this.showingPublishInterval = this.$store.state.showing.currentShowing.showingPublishInterval;
      this.showingPrivateComment = this.$store.state.showing.currentShowing.showingPrivateComment;
      this.openForRegistration = this.$store.state.showing.currentShowing.openForRegistration;
      this.showingPublic = this.$store.state.showing.currentShowing.showingPublic;
      this.showingComment = this.$store.state.showing.currentShowing.showingComment;
      this.notifySlotQuantity = this.$store.state.showing.currentShowing.notifySlotQuantity;
      this.notifySlotQuantityDeliveryWay = this.$store.state.showing.currentShowing.notifySlotQuantityDeliveryWay;
      this.showingId = this.$store.state.showing.currentShowing.id;
      this.$store.commit('showing/STORE_CURRENT_SHOWING', null);
    }
  }
}
</script>

<style scoped>
select {
  color: var(--fasad-orange);
}
.tab {
  border-bottom: 2px solid var(--fasad-grey-4);
}

.arrow {
  transform: rotate(180deg);
}

.tab.active .arrow {
  transform: rotate(0deg);
}

.comment-wrap {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.comment-wrap .customer-comment-btn {
  color: var(--fasad-orange);
  padding: 5px;
}

.customer-comment-input {
  box-shadow: 1px 2px 1px var(--fasad-grey-1);
  grid-column: 1 / -1;
}
</style>
